// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:599.98px){.v-toolbar__content[data-v-2fdd03a7]{padding-left:4px;padding-right:4px}}.focus[data-v-2fdd03a7]{margin-left:0.5rem;display:grid;width:14rem;grid-template-columns:repeat(9, minmax(0, 1fr));-moz-column-gap:0.25rem;column-gap:0.25rem;row-gap:0.5rem;border-radius:0.25rem;padding:0.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
